import { combineReducers } from 'redux'

import collections from './collections/reducer'
import dashboard from './dashboard/reducer'
import drivers from './drivers/reducer'
import orders from './orders/reducer'
import ordersForCollect from './ordersForCollect/reducer'
import queries from './queries/reducer'
import vehicles from './vehicles/reducer'

export default combineReducers({
  dashboard,
  orders,
  ordersForCollect,
  collections,
  queries,
  drivers,
  vehicles,
})
